var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"userPowerUnit"},[(_vm.skinName=="科技蓝")?_c('lightBlueusePowerUnit'):_c('navyUsePowerUnit')],1)}
var staticRenderFns = []

export { render, staticRenderFns }